import config from 'configAlias';
import values from 'lodash/values';
import * as analyticsActions from './actions';

const emitEvents = (state, action) =>
  values(analyticsActions)
    .filter(analyticsAction => typeof analyticsAction === 'function')
    .forEach(analyticsAction => {
      analyticsAction(state, action);
    });

export default store => next => action => {
  const result = next(action);

  if ((!window.TMS && !__DEV__) || !config.analytics) {
    return result;
  }

  const state = store.getState();

  emitEvents(state, action);

  return result;
};
